import React from 'react'

import type { HeaderProps as RBCHeaderProps } from 'react-big-calendar'

export interface HeaderProps extends RBCHeaderProps {}

export const Header: React.FC<HeaderProps> = ({ label }) => {
  return (
    <div className="flex items-center justify-center gap-4 py-2 -mx-2 text-sm font-semibold text-primary-900 dark:text-primary-100">
      <span className="hidden md:inline-block">{label}</span>
      <span className="md:hidden">{label.slice(0, 2)}</span>
    </div>
  )
}
